export const PLACEHOLDER_NODE_INTERNET_MESSAGE_ID = 'PLACEHOLDER_NODE_INTERNET_MESSAGE_ID';
export const PLACEHOLDER_NODE_ITEM_ID = 'PLACEHOLDER_NODE_ITEM_ID';
